<template>
  <DragDialog
    title="上传列表"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="closeDialog"
    class="uploadList"
  >
    <div class="common-card-tabs-box">
      <el-tabs v-model="activeTab" class="tab-page-primary" @tab-click="onTabClick">
        <el-tab-pane
          :label="`上传中(${fileUploadingList.length})`"
          name="uploading"
        >
          <div class="common-table-box">
            <el-table
            highlight-selection-row
            class="publish-table"
              v-if="activeTab === 'uploading'"
              height="100%"
              v-loading="tableLoading"
              :data="fileUploadingList"
            >
              <el-table-column label="序号" type="index" width="75" />
              <el-table-column label="文件名称" width="320">
                <template v-slot="{ row }">
                  <span class="text-overflow" :title="row.fileName">{{
                    row.fileName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="文件大小" width="120">
                <template v-slot="{ row }">
                  <span>{{
                    `${formatFileSize(row.length).fileSize}${
                      formatFileSize(row.length).unit
                    }`
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="上传进度" width="270">
                <template v-slot="{ row }">
                  <div v-if="row.status === -1 || row.status === -2">
                    等待上传
                  </div>
                  <ProgressBar
                    v-else
                    mark="dialog-"
                    :fileInfo="row"
                    :uploadControl="uploadControl"
                  />
                </template>
              </el-table-column>
              <el-table-column label="上传至">
                <template v-slot="{ row }">
                  <span class="text-overflow" :title="row.levelPath">
                    {{ row.levelPath }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template v-slot="{ row }">
                  <div class="common-button-box">
                    <el-button
                      type="text"
                      size="small"
                      :disabled="row.status === 1"
                      @click="deleteFileById(row)"
                      >移除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="common-empty-box">
                  <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
                    <template slot="description">
                      <div class="empty-text">抱歉，没有找到相关内容</div>
                    </template>
                  </bj-empty>
                </div>
              </template>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="`上传失败${
            fileUploadFailList.length ? `(${fileUploadFailList.length})` : ''
          }`"
          name="uploadFailed"
        >
          <div class="common-table-box">
            <el-table
            class="publish-table"
              v-if="activeTab === 'uploadFailed'"
              height="100%"
              v-loading="tableLoading"
              :data="fileUploadFailList"
            >
              <el-table-column
                label="序号"
                type="index"
                width="75"
              ></el-table-column>
              <el-table-column label="文件名称" width="320">
                <template v-slot="{ row }">
                  <span class="text-overflow" :title="row.fileName">{{
                    row.fileName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="文件大小" width="120">
                <template v-slot="{ row }">
                  <span>{{
                    `${formatFileSize(row.size).fileSize}${
                      formatFileSize(row.size).unit
                    }`
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="失败原因" width="270">
                <template v-slot="{ row }">
                  <div v-if="row.uploadStatus === 5">校验失败</div>
                  <div v-if="row.uploadStatus === 7">上传失败</div>
                </template>
              </el-table-column>
              <el-table-column label="上传至">
                <template v-slot="{ row }">
                  <span class="text-overflow" :title="row.levelPath">
                    {{ row.levelPath }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template v-slot="{ row }">
                  <div class="common-button-box operation-cell">
                    <el-button
                      type="text"
                      size="small"
                      @click="deleteFailFileById(row)"
                      >移除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="common-empty-box">
                  <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
                    <template slot="description">
                      <div class="empty-text">抱歉，没有找到相关内容</div>
                    </template>
                  </bj-empty>
                </div>
              </template>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import { Store } from "@/utils/store";

import {
  publicElemFileListService,
  privateElemFileListService,
  deleteFileService,
} from "@/service/interface";
import { formatFileSize } from "@/utils/generalMethods";
export default {
  data() {
    return {
      activeTab: "uploading",
      fileUploadingList: [],
      uploadingFileTotal: 0,
      fileUploadFailList: [],
      tableLoading: false,
    };
  },
  props: {
    visible: Boolean,
    type: String,
    elemUploader: Object,
    closeDialog: Function,
  },
  components: {
    DragDialog,
    ProgressBar,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initUploadList();
        this.queryFilesUploadFail();
      } else {
        this.clearTimer();
      }
    },
  },
  methods: {
    onTabClick(tab) {
      let name = tab.name;
      this.tableLoading = true;
      if (name === "uploading") {
        this.queryFilesUploading().then(() => {
          this.tableLoading = false;
        });
      } else {
        this.queryFilesUploadFail().then(() => {
          this.tableLoading = false;
          this.clearTimer();
        });
      }
    },
    initUploadList() {
      this.tableLoading = true;
      this.queryFilesUploading().then(() => {
        this.tableLoading = false;

        let isUploadingFlag = this.fileUploadingList.some(
          (el) => el.status === 0 || el.status === 1 || el.status === 2
        );
        if (isUploadingFlag && !this.timer) {
          this.timer = setInterval(this.refreshFileList, 1000);
        }
      });
    },
    deleteFileById(fileInfo) {
      if (fileInfo.status < 0) {
        let find = Store.uploaders.find(
          (el) => el.schemeType === fileInfo.schemeType
        );
        if (find) {
          let uploader = find.uploader;
          let findIndex = uploader.uploadFiles.findIndex((el) =>
            this.isSameFile(el, fileInfo)
          );
          if (findIndex !== -1) {
            uploader.uploadFiles.splice(findIndex, 1);
          }
        }
        return;
      }

      let fileDataId = fileInfo.id;
      deleteFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.$message.success("删除成功");
          this.refreshFileList();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    deleteFailFileById(fileInfo) {
      let fileDataId = fileInfo.id;
      deleteFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.$message.success("删除成功");
          this.queryFilesUploadFail();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    uploadControl(fileInfo) {
      let find = Store.uploaders.find(
        (el) => el.schemeType === fileInfo.schemeType
      );

      let uploader = find.uploader;
      let fileStatus = fileInfo.status;
      if (fileStatus === 1) {
        uploader.fire("pauseFileUpload", { fileInfo });
      }
      if (fileStatus === 2) {
        uploader.setStatus("continue");
        uploader.setCurrFileInfo(fileInfo);

        let pausedFiles = uploader.pausedFiles;
        let findPauseFile = pausedFiles.find(
          (el) => el.fileDataId === fileInfo.fileDataId
        );
        if (findPauseFile) {
          uploader.fire("continueFileUpload", { fileInfo });
        }
      }
    },
    refreshFileList() {
      this.queryFilesUploading().then(() => {
        let uploadingList = this.fileUploadingList.filter(
          (el) =>
            el.status === -1 ||
            el.status === -2 ||
            el.status === 0 ||
            el.status === 1 ||
            el.status === 2 ||
            el.status === 6
        );
        if (!uploadingList.length) {
          this.clearTimer();
        }

        let pauseList = this.fileUploadingList.filter((el) => el.status === 2);
        if (pauseList.length) {
          this.refreshDom();
        }
      });
    },
    queryElemUploadList(status) {
      return new Promise((resolve) => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          name: "",
          status,
        };
        if (this.type === "PublicElem") {
          publicElemFileListService(params).then((response) => {
            if (response.isSuccess) {
              let result = response.data;
              let fileUploadList = result.items;

              resolve(fileUploadList);
            }
          });
        } else {
          privateElemFileListService(params).then((response) => {
            if (response.isSuccess) {
              let result = response.data;
              let fileUploadList = result.items;

              resolve(fileUploadList);
            }
          });
        }
      });
    },
    queryFilesUploading() {
      return new Promise((resolve) => {
        this.queryElemUploadList([0, 1, 2, 6]).then((fileUploadingList) => {
          fileUploadingList.forEach((item) => {
            item["fileType"] = item.suffix;
            item["schemeType"] = item.scheme;
            item["status"] = item.uploadStatus;
            item["length"] = item.size;
            item["fileDataId"] = item.id;
            if (item.blobIndex || item.blobIndex === 0) {
              let currIndex = item["blobIndex"] + 1;
              let rate = Math.floor((currIndex / item.blobCount) * 10000);
              item["rate"] = rate;
            }
          });

          let customUploadList = [];
          let uploadFiles = this.elemUploader.uploadFiles;
          customUploadList = [...uploadFiles];

          let tempFileList = [];
          customUploadList.forEach((item) => {
            let findIndex = fileUploadingList.findIndex((el) =>
              this.isSameFile(item, el)
            );
            if (findIndex === -1) {
              tempFileList.push(item);
            } else {
              let status = fileUploadingList[findIndex].status;
              // 如果后端接口返回的状态不是上传中，则按前端状态显示
              if (status !== 0 && status !== 1 && status !== 6) {
                fileUploadingList[findIndex].status = item.status;
              }
            }
          });

          fileUploadingList = [...fileUploadingList, ...tempFileList];
          this.fileUploadingList = fileUploadingList;
          this.uploadingFileTotal = this.fileUploadingList.length;
          resolve();
        });
      });
    },
    queryFilesUploadFail() {
      return new Promise((resolve) => {
        this.queryElemUploadList([5, 7]).then((fileUploadFailList) => {
          this.fileUploadFailList = fileUploadFailList;
          resolve();
        });
      });
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    refreshDom() {
      this.fileUploadingList.forEach((item) => {
        let find = Store.uploaders.find(
          (el) => el.schemeType === item.schemeType
        );
        let uploader = find.uploader;
        let pausedFiles = uploader.pausedFiles;
        let findPauseFile = pausedFiles.find((el) => el.fileDataId === item.id);
        if (item.status === 2 && !findPauseFile) {
          let continueDom = document.getElementById(
            `dialog-continue-${item.id}`
          );
          if (continueDom) {
            if (
              !continueDom.children[0] ||
              !continueDom.children[0].className.includes("webuploader-pick")
            ) {
              uploader.uploader.addButton({
                id: `#dialog-continue-${item.id}`,
                multiple: false,
              });
            }
          }
        }
      });
    },
    isSameFile(fileInfo1, fileInfo2) {
      return (
        fileInfo1.fileName === fileInfo2.fileName &&
        fileInfo1.length === fileInfo2.length &&
        fileInfo1.fileDataId === fileInfo2.fileDataId
      );
    },
    formatFileSize,
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";

.uploadList{
  :deep(.dialog-content){
    padding-top: 4px;
  }
}
.common-card-tabs-box {
  height: 500px;

  /deep/ .el-tabs {
    height: 100%;

    .el-tabs__content {
      margin-top: 15px;
      .el-tab-pane {
        height: 100%;
      }
    }
  }

  .common-table-box {
    height: 100%;
    margin-bottom: 10px;
  }
}
</style>